/**
 * SINGLE SOURCE OF TRUTH for clinic info.
 * Edit values here and they propagate to:
 *   - JSON-LD (Google rich snippets)
 *   - Footer
 *   - Contact page
 *   - All Service / Product schemas
 *
 * TODO: replace placeholder values (marked // TODO) with real data.
 */

export const clinicInfo = {
  name: 'REHAM MANSOUR — קליניקה אסתטית וטבעית',
  legalName: 'Reham Mansour Clinic',
  founder: 'Reham Mansour',
  url: 'https://rihamclinic.lovable.app',
  logo: 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/Container.png?v=1778077042',
  image: 'https://cdn.shopify.com/s/files/1/0977/6965/2535/files/Container.png?v=1778077042',
  description:
    'קליניקה של רהאם מנסור במושב פטיש — שילוב של רפואה אסתטית מתקדמת, רוקחות טבעית וטיפולי שיער ועור מותאמים אישית.',
  priceRange: '₪₪',
  currency: 'ILS',

  // Contact — TODO: replace with real values
  telephone: '+972-50-1234567',
  telephoneDisplay: '050-1234567',
  email: 'info@reham.clinic',
  whatsapp: 'https://wa.me/972501234567', // TODO

  // Address — TODO
  address: {
    street: 'Moshav Patish 212',
    streetHe: 'מושב פטיש 212',
    locality: 'Moshav Patish',
    localityHe: 'מושב פטיש',
    region: 'Southern District',
    postalCode: '8536500', // TODO
    country: 'IL',
  },

  // Geo — TODO: replace with real coordinates from Google Maps
  geo: {
    latitude: 31.2345,
    longitude: 34.5678,
  },

  // Opening hours in Schema.org format
  // Mo,Tu,We,Th,Fr,Sa,Su
  openingHours: [
    { days: ['Mo', 'Tu', 'We', 'Th'], opens: '09:00', closes: '18:00' },
    { days: ['Fr'], opens: '09:00', closes: '13:00' },
  ],
  openingHoursDisplay: 'א׳-ה׳: 09:00 - 18:00 | ו׳: 09:00 - 13:00',

  // Social profiles — TODO: add real URLs
  social: {
    instagram: 'https://instagram.com/', // TODO
    facebook: 'https://facebook.com/', // TODO
    whatsapp: 'https://wa.me/972501234567', // TODO
  },
} as const;

/** Builds the MedicalBusiness JSON-LD block for the homepage. */
export function buildMedicalBusinessJsonLd() {
  return {
    '@context': 'https://schema.org',
    '@type': ['MedicalBusiness', 'LocalBusiness'],
    '@id': `${clinicInfo.url}/#clinic`,
    name: clinicInfo.name,
    legalName: clinicInfo.legalName,
    description: clinicInfo.description,
    url: clinicInfo.url,
    logo: clinicInfo.logo,
    image: clinicInfo.image,
    telephone: clinicInfo.telephone,
    email: clinicInfo.email,
    priceRange: clinicInfo.priceRange,
    currenciesAccepted: clinicInfo.currency,
    founder: { '@type': 'Person', name: clinicInfo.founder },
    address: {
      '@type': 'PostalAddress',
      streetAddress: clinicInfo.address.street,
      addressLocality: clinicInfo.address.locality,
      addressRegion: clinicInfo.address.region,
      postalCode: clinicInfo.address.postalCode,
      addressCountry: clinicInfo.address.country,
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: clinicInfo.geo.latitude,
      longitude: clinicInfo.geo.longitude,
    },
    openingHoursSpecification: clinicInfo.openingHours.map((slot) => ({
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: slot.days,
      opens: slot.opens,
      closes: slot.closes,
    })),
    areaServed: { '@type': 'Country', name: 'Israel' },
    sameAs: [
      clinicInfo.social.instagram,
      clinicInfo.social.facebook,
    ].filter(Boolean),
  };
}

/** Lightweight provider reference used inside Service / Product JSON-LD. */
export const providerRef = {
  '@type': 'MedicalBusiness',
  '@id': `${clinicInfo.url}/#clinic`,
  name: clinicInfo.legalName,
  url: clinicInfo.url,
};
